import { Box } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';

import { Preview } from '#features/ui/components/HelpPopover/HelpPopover.showcase';

export const Route = createFileRoute('/{-$locale}/_layout/preview/help-popover')({
  component: () => (
    <Box w="full" maxW="xl" mx="auto" p={4} pb={16}>
      <Preview />
    </Box>
  ),
});
